<template>
  <div class="wrapper">
    <div class="list">
      <Header v-bind:Top_query="Top_query" ref="header" />
      <div class="category_tab">
        <ul>
          <li :class="{ active: category == 1 }">
            <a :href="'#p=1-c=' + category" v-on:click="category = 1">ALL</a>
          </li>
          <li :class="{ active: category == 2 }">
            <a :href="'#p=1-c=' + category" v-on:click="category = 2">NEW</a>
          </li>
          <li :class="{ active: category == 3 }">
            <a :href="'#p=1-c=' + category" v-on:click="category = 3">TEMPLATE</a>
          </li>
        </ul>
      </div>
      <div class="project">
        <div class="project_results">
          <div class="project_results-box" v-if="query.k">
            <p class="project_results-title">
              <i class="fas fa-search"></i>
            </p>
            <div class="project_results-word">{{ query.k }}</div>
          </div>
          <div class="project_results-box" v-if="query.criteria">
            <p class="project_results-title">{{ query.criteria }}検索</p>
          </div>
          <div class="project_results-box" v-if="query.b_m_tag_pks">
            <p class="project_results-title">
              <i class="fas fa-tags"></i>
            </p>
            <ul class="project_results-list">
              <li v-for="pk in query.b_m_tag_pks" :key="pk">
                #
                {{ tagObj[pk] }}
              </li>
            </ul>
          </div>
          <div class="project_results-box" v-if="query.p_m_tag_pks">
            <p class="project_results-title">
              <i class="fas fa-tags"></i>
            </p>
            <ul class="project_results-list">
              <li v-for="pk in query.p_m_tag_pks" :key="pk">
                #
                {{ tagObj[pk] }}
              </li>
            </ul>
          </div>
          <div class="project_results-box" v-if="query.c_m_tag_pks">
            <p class="project_results-title">
              <i class="fas fa-tags"></i>
            </p>
            <ul class="project_results-list">
              <li v-for="pk in query.c_m_tag_pks" :key="pk">
                #
                {{ tagObj[pk] }}
              </li>
            </ul>
          </div>
          <p class="project_results-btn" v-if="Top_query">
            <button class="linebtn cl_wh_yl" v-on:click="dataClear">クリア</button>
          </p>
        </div>
        <ul class="project_list" v-if="proposalLists.length">
          <li v-for="(proposal, index) in proposalLists" :item="proposal" :key="index">
            <a :href="'/detail/' + proposal.pk + '/'">
              <i class="icon-new" v-if="proposal.new">NEW</i>
              <p class="project_list-img" v-if="proposal.thumbnail">
                <img :src="proposal.thumbnail" :alt="proposal.name" />
              </p>
              <p class="project_list-img no-image" v-else>
                <svg>
                  <use xlink:href="/svg/sprite.svg#logo" />
                </svg>
              </p>
              <p class="project_list-customer">{{ proposal.entdt }}</p>
              <p class="project_list-customer">{{ proposal.client_name }}</p>
              <p class="project_list-title">{{ proposal.name }}</p>
            </a>
          </li>
        </ul>
        <p class="nolist" v-else v-html="str_list"></p>
      </div>
      <div class="pager">
        <p class="pager_arrow" v-if="currentPage > 1">
          <a :href="'#p=' + backwardPage + '-c=' + category">
            <svg>
              <use xlink:href="/svg/sprite.svg#arrow_left" />
            </svg>
          </a>
        </p>
        <ul class="pager_list">
          <li v-for="pager in pagers" :key="pager.num">
            <span v-if="pager.isActive">{{ pager.num }}</span>
            <a :href="'#p=' + pager.num + '-c=' + pager.category" v-else>{{ pager.num}}</a>
          </li>
        </ul>
        <p class="pager_arrow" v-if="currentPage < forwardPage">
          <a :href="'#p=' + forwardPage + '-c=' + category">
            <svg>
              <use xlink:href="/svg/sprite.svg#arrow_right" />
            </svg>
          </a>
        </p>
      </div>
    </div>
    <modal name="alert" :width="600" :height="600">
      <div class="openalert">
        <h2 class="openalert_title">利用上の注意</h2>
        <p class="openalert_txt">
          登録されているデータは社外秘です。
          <br />下記禁止事項を理解し、正しく活用してください。
        </p>
        <h3 class="openalert_title02">禁止事項</h3>
        <ul class="openalert_list" v-html="opening_caution"></ul>
        <div class="openalert_button">
          <button v-on:click="hideModal('alert')" class="close"></button>
          <button type="button" v-on:click="hideModal('alert')" class="btn01 cl_bl">同意して利用する</button>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import { Mixin } from "../mixin";
export default {
  name: "Top",
  mixins: [Mixin],
  data() {
    return {
      Top_query: "",
      category: "1",
      query: {
        k: "",
        criteria: "",
        b_m_tag_pks: "",
        p_m_tag_pks: "",
        c_m_tag_pks: "",
      },
      tagObj: {},
      backwardPage: "",
      forwardPage: 2,
      currentPage: 1,
      maxItemPerPage: 24,
      proposalAllLists: [],
      proposalLists: [],
      pagers: [],
      str_list: "<strong>Loading..</strong>少々おまちください",
      opening_caution: "",
    };
  },
  created() {
    // --------
    // 初回表示
    // --------
    var self = this;
    // Loading Start
    var loader = this.loadingShow();
    this.getProposal().then((result) => {
      if (result) {
        //console.log(JSON.stringify(result))
        self.currentPage = this.getCurrentPage();
        self.proposalAllLists = result.values;
        self.opening_caution = result.opening_caution;
        //表示用のタグ取得
        this.getTag().then((result2) => {
          if (result2) {
            this.nowPage(self.currentPage);
            self.tagObj = result2.m_tag_pk;
            loader.hide();
          } else {
            //alert('failed.')
          }
        });
      } else {
        //alert('failed.')
        loader.hide();
      }
    });
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // ログイン時のみ
      const opening_caution_flg = vm.$cookies.get("lo_opening_caution"); // vm = thisの様に使える
      if (from.name == "login" && opening_caution_flg == 1)
        vm.showModal("alert");
    });
  },
  watch: {
    $route() {
      var self = this;
      // ブラウザバック
      // 検索対応
      self.currentPage = this.getCurrentPage();
      this.nowPage(self.currentPage);
      // お気に入り
      this.$refs.header.setFavoriteIcon();
    },
  },
  methods: {
    // ------------
    // 2回目以降表示
    // ------------
    nowPage: function (num) {
      var self = this;
      self.currentPage = num;
      //query取得
      const k = this.$route.query.k;
      const favorite = this.$route.query.favorite;
      const tagQueryObj = {
        b_m_tag_pk: this.$route.query.b_m_tag_pk,
        p_m_tag_pk: this.$route.query.p_m_tag_pk,
        c_m_tag_pk: this.$route.query.c_m_tag_pk,
      };
      const criteria = this.$route.query.criteria;
      //and orに対応するためいったん代入
      var proposalSearchLists = self.proposalAllLists;
      //------
      //query
      //------
      //フリーワード and検索対応
      if (k) {
        proposalSearchLists = proposalSearchLists.filter(function (item) {
          //タグを取得
          var tagStr;
          for (var tag in tagQueryObj) {
            var arr = item[tag];
            for (var i = 0; arr.length > i; i++) {
              tagStr += arr[i].name + "\t";
            }
          }
          //タグ+プロジェクト名
          tagStr += item.name;
          var k_arr = k.split(" ");
          for (i = 0; i < k_arr.length; i++) {
            //大文字・小文字
            if (
              tagStr.indexOf(k_arr[i].toLowerCase()) == -1 &&
              tagStr.indexOf(k_arr[i].toUpperCase()) == -1
            )
              return false;
          }
          return true;
        });
      }
      //タグ
      if (criteria == "AND") {
        if (tagQueryObj["b_m_tag_pk"])
          proposalSearchLists = this.searchTag(
            proposalSearchLists,
            tagQueryObj["b_m_tag_pk"],
            "b_m_tag_pk"
          );
        if (tagQueryObj["p_m_tag_pk"])
          proposalSearchLists = this.searchTag(
            proposalSearchLists,
            tagQueryObj["p_m_tag_pk"],
            "p_m_tag_pk"
          );
        if (tagQueryObj["c_m_tag_pk"])
          proposalSearchLists = this.searchTag(
            proposalSearchLists,
            tagQueryObj["c_m_tag_pk"],
            "c_m_tag_pk"
          );
      } else {
        var getLists = [];
        for (var tag in tagQueryObj) {
          if (tagQueryObj[tag]) {
            var arr = this.searchTag(
              proposalSearchLists,
              tagQueryObj[tag],
              tag
            );
            for (var i = 0; i < arr.length; i++) {
              getLists.push(arr[i]);
            }
          }
        }
        if (getLists.length)
          proposalSearchLists = this.filterUniqueItemsByPk(getLists);
      }
      //カテゴリ
      if (favorite == 1) {
        proposalSearchLists = proposalSearchLists.filter(function (item) {
          return item.favorite == 1;
        });
      }
      //NEW
      self.category = this.getHashCategory(); //ハッシュから取得
      if (self.category == 2) {
        proposalSearchLists = proposalSearchLists.filter(function (item) {
          return item.new == 1;
        });
      }
      //TEMPLATE
      if (self.category == 3) {
        proposalSearchLists = this.searchTag(
          proposalSearchLists,
          "28",
          "b_m_tag_pk"
        );
      }
      //------
      //turn
      //------
      //console.log(JSON.stringify(proposalSearchLists))
      //降順に並び替え
      // proposalSearchLists.sort(function (a, b) {
      //   a.pk = Number(a.pk);
      //   b.pk = Number(b.pk);
      //   if (a.pk > b.pk) return -1;
      //   if (a.pk < b.pk) return 1;
      //   return 0;
      // });
      self.proposalLists = proposalSearchLists.filter(function (item, index) {
        return (
          index < self.currentPage * self.maxItemPerPage &&
          index >= (self.currentPage - 1) * self.maxItemPerPage
        );
      });
      if (!self.proposalLists.length)
        self.str_list = "<strong>Sorry..</strong>検索結果がありません";
      //ページャー再生成
      self.pagers = this.getPager(
        proposalSearchLists.length,
        self.currentPage,
        self.maxItemPerPage
      );
      //表示用
      self.query.k = k;
      self.query.criteria = criteria;
      self.query.b_m_tag_pks = tagQueryObj["b_m_tag_pk"]
        ? tagQueryObj["b_m_tag_pk"].split("-")
        : "";
      self.query.p_m_tag_pks = tagQueryObj["p_m_tag_pk"]
        ? tagQueryObj["p_m_tag_pk"].split("-")
        : "";
      self.query.c_m_tag_pks = tagQueryObj["c_m_tag_pk"]
        ? tagQueryObj["c_m_tag_pk"].split("-")
        : "";
      //同じURLにアクセスさせない制御
      self.Top_query = location.search;

      //スクロールを最上位へ
      window.scrollTo({
        top: 0,
        behavior: "instant",
      });
    },
    // ------------
    // データ取得（初回のみ）
    // ------------
    getProposal() {
      let params = new URLSearchParams();
      params.append("c", "proposal-1");
      params.append("lo_pk", this.$cookies.get("lo_pk"));
      params.append("lo_sid", this.$cookies.get("lo_sid"));
      return this.axios
        .post(this.RequestURI, params, {
          headers: {
            "Cache-Control": "no-cache",
          },
        })
        .then((res) => {
          if (res.data.status == "success") {
            return res.data;
          } else {
            this.$router.push("/login/");
          }
        })
        .catch((e) => {
          console.log(this.$router);
          alert(e);
          this.$router.push("/login/");
        });
    },
    getPager: function (allCnt, currentPage, maxItemPerPage) {
      var self = this;
      currentPage = parseInt(currentPage);
      const maxPage = Math.ceil(allCnt / maxItemPerPage);
      // backward forward
      if (currentPage > 1) {
        self.backwardPage = currentPage - 1;
        if (maxPage > currentPage) self.forwardPage = currentPage + 1;
      } else {
        self.backwardPage = 1;
        self.forwardPage = !maxPage || maxPage == 1 ? "" : 2;
      }
      //カテゴリ取得
      const category = this.getHashCategory();
      //ページャー作成
      const tmp = new Array();
      for (var i = 0; i < maxPage; i++) {
        var isActive = i == currentPage - 1 ? true : false;
        tmp.push({
          num: i + 1,
          category: category,
          isActive: isActive,
        });
      }
      return tmp;
    },
    getCurrentPage: function () {
      // #p=1-c=1 に対応
      var hashArr = location.hash.split("-");
      for (var i = 0; hashArr.length > i; i++) {
        var hash = hashArr[i].split("=");
        hash[0] = hash[0].replace("#", "");
        if (hash[0] == "p") {
          return !hash[1] ? 1 : hash[1];
        }
      }
      return 1; // #p=が無ければ強制1
    },
    searchTag: function (proposalSearchLists, tag, target) {
      //タグ検索用
      const m_tag_pks = tag.split("-");
      var tmp = proposalSearchLists.filter(function (item) {
        return Object.keys(item[target]).filter(function (i) {
          return m_tag_pks.indexOf(item[target][i].pk) != -1
        }).length
      });
      return tmp;
    },
    filterUniqueItemsByPk(arr) {
      //or検索対応。オブジェクト in 配列をpkでユニーク化
      const itemPk = arr.map(function (item) {
        return item.pk;
      });
      //
      return arr.filter(function (item, index) {
        return itemPk.indexOf(item.pk) === index;
      });
    },
    dataClear() {
      this.$refs.header.dataClear();
      this.$router.push("/");
    },
  },
};
</script>
